/** Tries to log. If fails to log, ignores failure. */
export function tryLogAndIgnoreFailure(logFunc: () => Promise<unknown>): void {
  // don't await for the log to resolve
  logFunc().catch(() => {
    // Intentionally ignore any logging failures.
  });
}
